import { useState } from 'react'
import styled from 'styled-components'

import TrackVisibility from '../../components/utils/TrackVisibility'
import MapWithListing, {
  ListingPopupData,
} from '../../components/maps/ListingMap'
import { snakeCaseKeys } from '../../components/utils/propsUtils'

const MapWrapper = styled.div`
  width: 100%;
  height: 550px;
`

export type AdventureMapProps = {
  adventureData: Omit<GQL_AdventureCardFragmentFragment, 'photos' | 'url'>
  photos?: Pick<GQL_Photo, 'id' | 'image' | 'aspectRatio' | 'position'>[]
  originalListing?: Pick<GQL_Listing, 'id' | 'coordinates'> & {
    subcategory?: Pick<GQL_ListingSubcategory, 'slug'>
  }
}

const AdventureMap = ({
  adventureData,
  photos,
  originalListing,
}: AdventureMapProps) => {
  const [showMap, setShowMap] = useState(false)

  const listingForMap = originalListing && {
    id: originalListing?.id,
    type: 'Listing' as GQL_Searchable,
    slug: originalListing?.subcategory?.slug,
    location: originalListing?.coordinates,
    listing: snakeCaseKeys(originalListing) as ListingPopupData,
  }

  const adventureForMap = {
    id: adventureData?.id,
    type: 'Adventure' as GQL_Searchable,
    slug: adventureData?.adventureType?.slug,
    location: [adventureData?.location?.lat, adventureData?.location?.lng],
    adventure: ({
      ...adventureData,
      photos,
    } as unknown) as Omit<GQL_AdventureCardFragmentFragment, 'url'>,
  }

  return (
    <TrackVisibility
      onChange={(isVisible: boolean) => {
        if (isVisible) setShowMap(true)
      }}
    >
      <MapWrapper>
        <MapWithListing
          listing={listingForMap}
          adventures={[adventureForMap]}
          analyticsSource="adventure_page"
          hide={!showMap}
        />
      </MapWrapper>
    </TrackVisibility>
  )
}

export default AdventureMap
